import { Box, Stack } from '@mui/material';
import { useListEmailTemplatesQuery } from 'api/client-domain/email-template-service/email-template-service';
import SearchDataCardGrid from 'components/search/search-data-card-grid/search-data-card-grid.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import { useSearch } from 'components/search/search.hooks';
import {
  booleanSearchParam,
  defaultSearchParams,
  querySearchParam,
  stringSearchParam,
} from 'components/search/search.utils';
import { useTranslation } from 'react-i18next';
import SearchDataCard from '../../search-data-card/search-data-card.component';
import { EmailTemplateTypes } from '../../email-templates.utils';

const EventEmails = () => {
  const { t } = useTranslation();

  const emailTemplates = useSearch(useListEmailTemplatesQuery, [
    ...defaultSearchParams({
      count: 9,
      page: 0,
    }),
    querySearchParam('name', { defaultValue: '' }),
    stringSearchParam('emailTemplateType', {
      defaultValue: EmailTemplateTypes.EVENT,
    }),
    booleanSearchParam('reusable', { defaultValue: true }),
  ]);

  return (
    <Box py={2}>
      <SearchProvider value={emailTemplates}>
        <Stack gap={3}>
          <SearchToolbar
            searchInputLabel={t(
              'page.communications.emailTemplates.tabs.loyaltyRewardEmails.searchInput.placeholder',
            )}
          />
          <SearchDataCardGrid
            CardComponent={SearchDataCard}
            data-testid="Event.SearchDataCardGrid"
            emptyDataText={t(
              'page.communications.emailTemplates.tabs.eventEmails.emptyDataText',
            )}
          />
        </Stack>
      </SearchProvider>
    </Box>
  );
};

export default EventEmails;
